// @flow
import * as React from 'react'
import { eventToKey } from 'mz-ui-kit/utils'

type Props = {
  render: Function,
  acceptedKeys: Array<string>,
}

/**
 * Component that adds ability to "select" element by using keyboard keys
 */
class KeyboardSelectable extends React.Component<Props> {
  static defaultProps = {
    acceptedKeys: ['Enter', 'Space'],
  }

  handleKeyDown = (handler: Function) => (event: Object) => {
    const { acceptedKeys } = this.props
    const key = eventToKey(event)

    if (acceptedKeys.includes(key)) {
      event.preventDefault()
      handler && handler(event)
    }
  }

  render() {
    return this.props.render({ keyDownHandler: this.handleKeyDown })
  }
}

export default KeyboardSelectable
